import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-confirm',
  template: `<mat-card-title class="full-width" fxLayout="row">
  <span>{{ data.title|translate }}</span>
</mat-card-title>
<div class="pb-1 popup-width">
  <mat-divider></mat-divider>
</div>
<p *ngIf="data.prevediPoruku" mat-dialog-content [innerHTML]="data.message|translate"></p>
<p *ngIf="!data.prevediPoruku" mat-dialog-content [innerHTML]="data.message"></p>
<div fxLayout="row" fxLayoutAlign="end none" fxLayoutGap="20px" class="pt-1">
  <div fxLayoutGap="10px">
    <button data-testid="btnObrisi" class="full-width" mat-raised-button color="primary" (click)="dialogRef.close(true)">
      <mat-icon>done</mat-icon>
      {{ "general.accept" | translate }}
    </button>
  </div>
  <div fxLayoutGap="10px">
    <button data-testid="btnOtkazi" class="full-width white-button" (click)="dialogRef.close(false)" mat-raised-button>
      <mat-icon>close</mat-icon>
      {{ "general.cancel" | translate }}
    </button>
  </div>
</div>`,
styles: [`
  .popup-width{
    width: 600px;
  }
`]
})
export class GenericConfirmComponent {

  constructor(public dialogRef: MatDialogRef<GenericConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {title: string, message: string, question: boolean,  prevediPoruku: boolean }) {
      if(data?.prevediPoruku == undefined) data.prevediPoruku = true;
  }
}
